import Button from "@app/components/button";
import { addToast } from "@app/components/toast/toast.service";
import { RoutePath, SystemMessage } from "@app/constants";
import CopyIcon from "@app/icons/copy";
import WalletService from "@app/services/http/wallet.service";
import { PurchaseVasQr } from "@app/types";
import { fancyTimeFormat, formatMoneyVN, fromUnixTime } from "@app/utils/util";
import { useCopyToClipboard } from "@core/hooks/use-copy-to-clipboard.hook";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

function VasQrInfo() {
  const { productId } = useParams();
  const [data, setData] = useState<PurchaseVasQr>();
  const [timeLeft, setTimeLeft] = useState(0);

  const navigate = useNavigate();
  const [, copy] = useCopyToClipboard();

  useEffect(() => {
    if (!productId) {
      navigate(RoutePath.VAS_OPTION_LIST);

      return;
    }

    WalletService.showQr({ productId }).then((res) => {
      setData(res.data);

      setTimeLeft(
        fromUnixTime(res.data.expiredTime).diff(new Date(), "seconds")
      );

      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }, [productId]);

  useEffect(() => {
    if (!data || timeLeft === 0) return;

    const interval = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, [data, timeLeft]);

  const handleCopy = (text: string | undefined) => {
    if (!text) return;

    copy(text).then(() => {
      addToast({ text: SystemMessage.COPY_SUCCESSFULLY });
    });
  };

  return (
    <div className="w-full flex items-center justify-center py-[20px]">
      <div className="max-w-[608px] w-full">
        <p className="text-center text-[#FC4040] font-semibold">
          Thời gian còn lại: {fancyTimeFormat(timeLeft)}
        </p>
        <div className="flex flex-col gap-[12px] mt-[40px]">
          <div className="">
            <p className="text-[#333B47] font-medium">
              Ngân hàng: {data?.bankName}
            </p>
          </div>
          <div className="">
            <p className="text-[#333B47] font-medium">
              Chủ tài khoản: {data?.ownerName}
            </p>
          </div>
          <div className="flex justify-between items-center">
            <p className="text-[#333B47] font-medium">
              Số tài khoản: {data?.bankNumber}
            </p>
            <div
              className="cursor-pointer hover:opacity-70"
              onClick={() => handleCopy(data?.bankNumber)}
            >
              <CopyIcon />
            </div>
          </div>
          <div className="flex justify-between items-center">
            <p className="text-[#333B47] font-medium">
              Số tiền: <b>{!!data?.price && formatMoneyVN(data?.price)} VND</b>
            </p>
            <div
              className="cursor-pointer hover:opacity-70"
              onClick={() => handleCopy(data?.price.toString())}
            >
              <CopyIcon />
            </div>
          </div>
          <div className="flex justify-between items-center">
            <p className="text-[#333B47] font-medium">
              Nội dung: {data?.content}
            </p>
            <div
              className="cursor-pointer hover:opacity-70"
              onClick={() => handleCopy(data?.content)}
            >
              <CopyIcon />
            </div>
          </div>
        </div>

        <div className="py-[40px] flex flex-col items-center">
          <div className="w-[400px]">
            <img
              src={data?.qrCode}
              alt="qr code"
              className="w-[400px] h-[400px]"
            />
            <div className="mt-[40px] flex justify-between gap-[24px]">
              <Button
                containerClassName="flex-1"
                label="Hủy"
                className="!bg-[#ECEEF2] !text-[#424E62] !text-[18px] !font-bold !h-[42px] !rounded-[26px]"
                onClick={() => navigate(RoutePath.VAS_OPTION_LIST)}
              />
              <Button
                containerClassName="flex-1"
                label="Đã chuyển"
                className="!bg-[linear-gradient(180deg,#5A82D7,#4667CA)] !text-[#FFF] !text-[18px] !font-bold !h-[42px] !rounded-[26px]"
                onClick={() => navigate(RoutePath.USER_WALLET)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VasQrInfo;
